import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { Tabs, Tab } from '../../core/Tabs';
import Buttons from '../../core/Buttons';
import Icon from '../../core/Icon';
import Day from '../../core/Day';
import { API } from '../../../constants/api';

export const StyledBoxMenu = styled.div`
  margin-top: ${rem('60px')};
  position: relative;

  ${mediaqueries.greaterThan('mobile')`
    margin-top: 0;
  `};
`;

export const StyledBoxMenuWeekly = StyledBoxMenu.extend`
  margin-top: 0;

  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.grayLightest};
    display: table-cell;
    vertical-align: top;
    width: 100%;
  `};
`;

export const StyledButtonWeek = styled(Buttons)`
  background-color: #e4522d;
  margin-right: ${rem('10px')};
`;

export const StyledBoxMessage = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  min-height: ${rem('271px')};
  padding-top: ${rem('55px')};
  position: relative;
  text-align: center;
  width: 100%;

  ${mediaqueries.greaterThan('mobile')`
    min-height: ${rem('310px')};
    padding-top:${rem('110px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    padding-left: ${rem('74px')};
    padding-right: ${rem('74px')};
  `};
`;

export const StyledWrapperBox = styled.div`
  ${mediaqueries.lessThan('mobile')`
    max-width: ${rem('248px')};
    margin: 0 auto;
  `};
`;

export const StyledBoxMessageWeekly = StyledBoxMessage.extend`
  ${mediaqueries.greaterThan('desktop')`
    padding-right:${rem('40px')};
    padding-left:${rem('40px')};
  `};
`;

export const StyledMessageTitle = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const StyledMessageTitleWeekly = StyledMessageTitle.extend``;

export const DetailMessageTitle = styled.span`
  display: block;
  font-family: inherit;
  line-height: inherit;

  ${mediaqueries.greaterThan('desktop')`
    display: inline;
  `};
`;

export const StyledButtonLight = styled(Buttons)`
  background-color: ${props => props.theme.colors.success};
`;

export const StyledBoxButtons = styled.div`
  align-items: center;
  display: flex;
  align-items: center;
  display: flex;
`;

export const StyledBoxPricipal = styled.div`
  background: ${props => props.theme.colors.grayLightest};
`;

export const TabsMenu = styled(Tabs)`
  &:last-child {
    max-height: inherit;
    min-height: inherit;
    overflow-y: hidden;
  }

  ${mediaqueries.greaterThan('mobile')`
    &:last-child {
      height: ${rem('340px')};
    }
  `};
`;

export const TabsMenuWeekly = TabsMenu.extend`
  ${mediaqueries.greaterThan('desktop')`
    ul {
      width: ${rem('209px')};
    }
  `};
`;

export const StyledMenuWellness = styled.div`
  background-color: ${props => props.theme.colors.activeBlue};
  vertical-align: middle;

  ${mediaqueries.lessThan('mobile')`
    display: none;
  `};
`;

export const StyledMenuWellnessWeekly = StyledMenuWellness.extend`
  ${mediaqueries.greaterThan('desktop')`
    border-left: ${rem('10px')} solid ${props => props.theme.colors.light};
  `};
`;

export const StyledBoxSpecial = styled.div`
  align-items: center;
  display: flex;
  height: ${rem('74px')};
  overflow: hidden;
  position: relative;
  background: ${props => props.theme.colors.grayLightest}
    url(${css`${API}${props => props.imageUrl}`}) no-repeat center center /
    cover;

  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('130px')};
  `};
`;

export const StyledBoxSpecialWeekly = StyledBoxSpecial.extend`
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('61px')};
  `};
`;

export const StyledDay = styled(Day)`
  position: absolute;
  right: 0;
  top: ${rem('-29px')};
  z-index: 1;

  ${mediaqueries.greaterThan('mobile')`
    top: 0;
  `};
`;

export const StyledTitleSpecial = styled.h3`
  background: ${props => props.theme.colors.light}b3;
  color: ${props => props.theme.colors.dark};
  margin: 0;
  overflow: hidden;
  padding: ${rem('13px')} ${rem('10px')};
  position: absolute;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  top: 50%;
  transform: translate(0, -50%);
  white-space: nowrap;
  width: 90%;

  ${mediaqueries.lessThan('mobile')`
    font-size: ${rem('15px')};
    padding-bottom: ${rem('5px')};
    padding-top: ${rem('5px')};
    width: 100%;
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('18px')};
    width: ${rem('450px')};
  `};
`;

export const StyledTitleSpecialWeekly = StyledTitleSpecial.extend`
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('5px')} ${rem('10px')};
    width: ${rem('478px')};
  `};
`;

export const StyledInterior = styled.div`
  border-top: ${rem('2px')} solid ${props => props.theme.colors.grayLight};
  padding: ${rem('19px')} ${rem('10px')};
  position: relative;

  ${mediaqueries.greaterThan('mobile')`
    border: 0;
    padding: ${rem('30px')} 0 ${rem('30px')} 1.5rem;
    width: 86%;

    ${props =>
      props.columns > 1 &&
      `
      columns: ${props.columns};
      column-gap: ${rem('20px')};
    `};    
  `};
`;

export const StyledInteriorWeekly = StyledInterior.extend`
  ${mediaqueries.greaterThan('desktop')`
    padding-top:${rem('23px')};
  `};
`;

export const StyledContent = styled.dl`
  break-inside: avoid-column;
  display: table;
  margin-bottom: ${rem('12px')};
  padding-left: ${rem('12px')};

  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }

  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: 0;
    width: 100%;
  `};
`;

export const StyledImage = styled.img`
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    height:100%;
  `};
`;

export const StyledTitleList = styled.dt`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('14px')};
  margin-bottom: ${rem('6px')};
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    font-family: ${props => props.theme.fonts.medium};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size:${rem('13px')};
  `};
`;

export const StyledListFood = styled.dd`
  font-size: ${props => props.theme.fontSize.small};
  margin: 0 0 ${rem('3px')} 0;
  padding-left: 0;

  &:last-child {
    margin-bottom: 0;
  }

  ${mediaqueries.greaterThan('mobile')`
    font-size: inherit;
    margin: 0;
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

export const StyledBoxDown = styled.div`
  text-align: right;
  display: flex;
  justify-content: space-between;
  padding-top: ${rem('15px')};

  ${mediaqueries.greaterThan('mobile')`
      margin-top:0;
  `};
`;

export const StyledBoxDownWeekly = StyledBoxDown.extend`
  position: relative;
  z-index: 2;
  padding-bottom: ${rem('20px')};
  display: block;
  ${mediaqueries.greaterThan('desktop')`
    margin-top: 0;
    position: absolute;
    right: 0;
    top: ${rem('2px')};
    width: ${rem('640px')};;
    display: flex;
  `};
  .alergenos {
    ${mediaqueries.greaterThan('desktop')`
    position: absolute;
    right: 0;
    top: ${rem('106px')};
  `};
  }
`;

export const StyledIcon = styled(Icon)`
  cursor: default;
  margin-bottom: ${rem('3px')};
  ${mediaqueries.lessThan('mobile')`
    margin-right: ${rem('10px')};
  `};
`;

export const StyledIconWeekly = StyledIcon.extend`
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('48px')};
    margin-right: ${rem('20px')};
    width: ${rem('48px')};
  `};
`;

export const StyledIconRazor = styled(Icon)`
  bottom: 0;
  position: absolute;
  right: ${rem('30px')};
  width: ${rem('47px')};

  ${mediaqueries.greaterThan('mobile')`
    right: ${rem('20px')};
    width: ${rem('74px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    right: ${rem('40px')};
    width: ${rem('51px')};
  `};
`;

export const StyledBoxImages = styled.div`
  margin-top: ${rem('-12px')};
  z-index: 2;

  ${props =>
    props.wellness &&
    css`
      position: relative;
      top: ${rem('4px')};
      &:first-child {
        &:after {
          background-color: #c5d8ab;
        }
      }
    `};
`;

export const StyledIconAllergies = styled(Icon)`
  &:hover {
    fill: ${props => props.theme.colors.colorThree};
  }
`;

export const StyledIconCam = styled(Icon)`
  margin-left: ${rem('30px')};
  &:hover {
    fill: ${props => props.theme.colors.colorThree};
  }
`;

export const StyledText = styled(Icon)`
  cursor: default;
  height: ${rem('25px')};
  margin-bottom: ${rem('4px')};
  width: auto;
  z-index: 2;

  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('2px')};
    width: ${rem('120px')};
  `};
`;

export const StyledTextWeekly = StyledText.extend`
  ${mediaqueries.greaterThan('desktop')`
    margin-left: 1rem;
    width: ${rem('161px')};
  `};
`;

export const StyledTab = styled(Tab)`
  ${props =>
    props.wellness &&
    css`
      background-color: ${props => props.theme.colors.activeBlue};
    `};

  ${mediaqueries.greaterThan('tablet')`
    ${props =>
      (props.hidden || props.wellness) &&
      css`
        display: none;
      `};
  `};
`;

export const StyledTabWeekly = StyledTab.extend`
  ${mediaqueries.greaterThan('desktop')`
    &:after,
    & div:after {
      width: ${rem('212px')};
    }
  `};
`;

export const StyledBookTable = styled.a`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.light};
  background-color: ${props => props.theme.colors.primary};
  padding: ${rem('8px')} ${rem('15px')};
  text-transform: uppercase;
  transition: 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: ${rem('300px')};
  margin-bottom: ${rem('10px')};
  &.black {
    background-color: ${props => props.theme.colors.dark};
    color: ${props => props.theme.colors.light};
    &:hover {
      background-color: ${props => props.theme.colors.grayDarker};
    }
  }

  &:hover {
    background-color: ${props => props.theme.colors.dark};
  }

  .icon-reserv {
    fill: ${props => props.theme.colors.light};
    margin-right: ${rem('10px')};
  }

  ${mediaqueries.greaterThan('desktop')`
      text-align: center;
  `};
`;
